// extracted by mini-css-extract-plugin
export default {"tradeTitle":"styles_tradeTitle__Ctw6C","workerList":"styles_workerList__vRVAX"};